import { ApiKey, BaseUrl } from '../global'
import axios from 'axios'

export const initialData = async (id, source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/ShipperAdvice/GetInitData?id=' + id, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const getAdvices = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/ShipperAdvice/GetAdvices', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const getTicketDetails = async (cn, source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/ShipperAdvice/TicketDetails?cn=' + cn, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const saveAdvice = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/ShipperAdvice/SaveAdvice', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const BulkSaveAdvice = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/ShipperAdvice/BulkSaveAdvice', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}